export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["If you see this, the form was not submitted (but you shouldn't see this)"])}
}